$(document).ready(function() {
  
  console.log("tester");
  
    $(".custom_subcollections-menu__link-list .sub-menu   i").click(function(e) {
      e.stopPropagation();
       $(this).next().toggleClass('show_child');
  });

// $('ul.tabs li').click(function(){
//       var tab_id = $(this).attr('data-tab');

//       $('ul.tabs li').removeClass('current');
//       $('.tab-content').removeClass('current');

//       $(this).addClass('current');
//       $("#"+tab_id).addClass('current');
//     })

  
    $(".product-section--wrapper .tab_content").hide();
    $(".product-section--wrapper .tab_content:first").show();

  /* if in tab mode */
    $(".product-section--wrapper ul.tabs li").click(function() {
		
      $(".product-section--wrapper .tab_content").hide();
      var activeTab = $(this).attr("rel"); 
      $(".product-section--wrapper #"+activeTab).fadeIn();		
		
      $(".product-section--wrapper ul.tabs li").removeClass("active");
      $(this).addClass("active");

	  $(".product-section--wrapper .tab_drawer_heading").removeClass("d_active");
	  $(".product-section--wrapper .tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");
	  
    });
	/* if in drawer mode */
	$(".product-section--wrapper .tab_drawer_heading").click(function() {
      
      $(".product-section--wrapper .tab_content").hide();
      var d_activeTab = $(this).attr("rel"); 
      $(".product-section--wrapper #"+d_activeTab).fadeIn();
	  
	  $(".product-section--wrapper .tab_drawer_heading").removeClass("d_active");
      $(this).addClass("d_active");
	  
	  $(".product-section--wrapper ul.tabs li").removeClass("active");
	  $(".product-section--wrapper ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");
    });

	$('.product-section--wrapper ul.tabs li').last().addClass("tab_last");

$('.add').click(function () {
		if ($(this).prev().val() < 3) {}
    	$(this).prev().val(+$(this).prev().val() + 1);
		
});
$('.sub').click(function () {
		if ($(this).next().val() > 1) {
    	if ($(this).next().val() > 1) $(this).next().val(+$(this).next().val() - 1);
		}
});
  
});